import {useState, useMemo} from 'react'
import styled from 'styled-components'
import useRouter from 'hooks/useRouter'
import {
  Button, Text, Dialog, Card, Icon, Flex, FlexBetween, Box, TextField
} from '@binance/uikit'
import {onInputChange, onKeyPress, onBlur} from 'utils/limitInput'
import useSymbolInfo from 'hooks/useSymbolInfo'
import useGetUserAssetProvider from 'hooks/useGetUserAssetProvider'
import useGetUserAsset from 'hooks/useGetUserAsset'
import useGetMaxWithdrawProvider from 'hooks/useGetMaxWithdrawProvider'
import useGetMaxWithdraw from 'hooks/useGetMaxWithdraw'
import handleTransfer from 'hooks/useTransferAsset'
import {getPowOf} from 'utils/common'
import {floor} from 'utils/number'

const MessageBoxWrap = styled(Card)`
  align-items: center;
  border-radius: 3px;
  color: #848e9c;
  background-color: #2a2f37;

  .close-icon {
    position: absolute;
    right: -40px;
    top: -8px;
    padding: 7px 10px;
    cursor: pointer;
    font-weight: 600;
  }

  .amount-input {
    > div > div {
      background: unset;

      > div {
        background: unset;
        height: 21px;
        padding: 0;
        width: 250px;
      }
    }
  }

  .asset-icon {
    width: 18px;
    height: 18px;
    border: 1px solid #48515d;
    border-radius: 100%;
    padding: 4px;
  }

  .white-text {
    font-size: 14px;
    color: #fff;
    width: 189px;
  }

  .transfer-side {
    > div + div {
      width: 54%;
    }

    .box {
      background: #48515d;
      border-radius: 20px;
      padding: 11px 0;
      width: 189px;
      font-weight: 600;
      font-size: 14px;
      color: #fff;
    }

    .icon {
      width: 32px;
      margin: 2px 16px 0 0;
      cursor: pointer;

      + i {
        width: 0;
      }
    }
  }

  @media only screen and (max-width: 414px) {
    width: auto;

    .close-icon {
      top: 4px;
      right: 0px;
    }

    .content-box {
      width: auto;
      padding: 0 22px 32px;

      .white-text {
        width: 136px;
      }

      .transfer-side {
        .box {
          width: 136px;
        }
      }

      .amount-input > div > div {
        width: 100px;
      }
    }
  }
`

export default function TransferDialog (props) {
  const [side, setSide] = useState(true)
  const [amount, setAmount] = useState('')
  const {onClose, i18n} = props
  const boxWidth = 506
  const contentP = 32
  const contentW = boxWidth - contentP * 2

  const router = useRouter()
  const {lng = 'en'} = router.query
  const {symbolInfo} = useSymbolInfo()
  const {quoteAsset, pricePrecision, maxLen} = symbolInfo
  useGetUserAssetProvider(quoteAsset)
  useGetMaxWithdrawProvider()
  const userAsset = useGetUserAsset()
  const maxWithdrawAmount = useGetMaxWithdraw()
  const userBalance = (side ? userAsset?.free : maxWithdrawAmount) || 0
  const isInvalidAmount = Number(amount) > Number(userBalance)
  const isInvalidIpt = amount !== '' && (Number(amount) <= 0 || isInvalidAmount)
  const setInputAmount = (type, num) => setAmount(num)

  return useMemo(
    () => (
      <Dialog visible={true}>
        <MessageBoxWrap width={boxWidth}>
          <div className="close-icon" onClick={onClose}>
            <Icon color="#fff" hover="#A9B0BA" size={16} name="close1" />
          </div>
          <Text.Base
            width="100%"
            py={18}
            fontSize={22}
            fontWeight={500}
            textAlign="center"
            borderBottom="2px solid #F0B90B"
          >
            {i18n.transfer || 'Transfer'}
          </Text.Base>
          <Box px={contentP} pb={contentP} width={contentW} className="content-box">
            <Box mt={32} mb={6} width="100%">
              <FlexBetween
                height="16px"
                before={
                  <Text.Caption className="white-text">{i18n.fromLabel || 'From'}</Text.Caption>
                }
                text=""
                after={<Text.Caption className="white-text">{i18n.toLabel || 'To'}</Text.Caption>}
                textAlign="center"
              />
            </Box>
            <Box width="100%">
              <FlexBetween
                height="16px"
                before={
                  side ? (
                    <span className="box">{i18n.exchangeWalletLabel || 'Exchange Wallet'}</span>
                  ) : (
                    <span className="box">{i18n.futureWalletLabel || 'Future Wallet'}</span>
                  )
                }
                text={
                  <span className="icon" onClick={() => setSide(!side)}>
                    <img src={require('./transfer.svg')} alt="" />
                  </span>
                }
                after={
                  side ? (
                    <span className="box">{i18n.futureWalletLabel || 'Future Wallet'}</span>
                  ) : (
                    <span className="box">{i18n.exchangeWalletLabel || 'Exchange Wallet'}</span>
                  )
                }
                textAlign="center"
                className="transfer-side"
              />
            </Box>
            <Box width="100%" mt={36}>
              <Text.Caption width={120} style={{fontSize: '14px'}}>
                {i18n.coinLabel || 'Coin'}
              </Text.Caption>
              <FlexBetween
                height="16px"
                before={
                  <>
                    <img className="asset-icon" src={require('./asset-usdt.png')} alt="" />
                    <span style={{color: '#fff', fontSize: '20px', margin: '0 8px'}}>
                      {quoteAsset}
                    </span>
                    <span style={{color: '#848E9C', fontSize: '16px', marginTop: '2px'}}>
                      {i18n.tetherUSLabel || 'TetherUS'}
                    </span>
                  </>
                }
                text={<span></span>}
                after={<span></span>}
                mt={4}
                pb={3}
                borderBottom="1px solid #48515D"
              />
            </Box>
            <Box width="100%" mt={26} className="amount-box">
              <Text.Caption style={{fontSize: '14px'}}>
                {i18n['tradeHistory-amountTitle'] || 'Amount'}
              </Text.Caption>
              <FlexBetween
                height="16px"
                before={
                  <TextField
                    type="number"
                    value={amount}
                    step={getPowOf(pricePrecision)}
                    min="0"
                    onKeyPress={e => onKeyPress(e, maxLen)}
                    handleChange={e => onInputChange(e, setInputAmount, '', pricePrecision)}
                    onBlur={e => onBlur(e)}
                    placeholder={i18n.typeYouAmount || 'Type your Amount'}
                    fontSize={16}
                    mt={1}
                  />
                }
                text=""
                after={
                  <Text.Caption
                    style={{color: '#F0B90B', cursor: 'pointer'}}
                    onClick={() => {
                      setAmount(floor(userBalance, 2))
                    }}
                  >
                    {i18n.availableLabel || 'Available'}: {floor(userBalance, pricePrecision, true)}{' '}
                    {quoteAsset}
                  </Text.Caption>
                }
                mt={4}
                pb={3}
                borderBottom="1px solid #48515D"
                className="amount-input"
              />
              {isInvalidIpt && (
                <Text.Caption
                  style={{
                    fontSize: '12px',
                    color: '#F23051',
                    lineHeight: '16px',
                    margin: '-6px 0 -16px'
                  }}
                >
                  {isInvalidAmount ? i18n.validAmountTip1 : i18n.validAmountTip2}
                </Text.Caption>
              )}
            </Box>
            <Flex width="100%" mt={46}>
              <Button
                bg="primary"
                color="#212833"
                width="100%"
                height={40}
                onClick={() => {
                  if (!isInvalidIpt) {
                    handleTransfer(i18n, lng, amount, quoteAsset, side ? 'IN' : 'OUT')
                    onClose()
                  }
                }}
              >
                {i18n.confirmTransfer || 'Confirm transfer'}
              </Button>
            </Flex>
          </Box>
        </MessageBoxWrap>
      </Dialog>
    ),
    [
      onClose,
      i18n,
      contentW,
      side,
      quoteAsset,
      amount,
      pricePrecision,
      userBalance,
      isInvalidIpt,
      isInvalidAmount,
      maxLen,
      lng
    ]
  )
}
